import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const rightRow: SxStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
};

export const footer: SxStyle = {
  color: (p) => p.palette.grey[500],
  fontSize: (p) => p.typography.body5,
  fontWeight: 400,

  '& span': {
    color: (p) => p.palette.primary[500],
    fontSize: (p) => p.typography.body5,
    fontWeight: 700,
  },
};
